import { useMemo } from "react";

import {
  getAgentColor,
  getAgentSeatCount,
  getAgentRevenue,
} from "../helpers/calculations";
import { BusMapData } from "../types/app.types";

export interface AgentData {
  name: string;
  color: string;
  seatCount: number;
  revenue: number;
}

export const useAgentsData = (busMapData: BusMapData | null): AgentData[] => {
  return useMemo(() => {
    if (!busMapData) return [];

    const agentsSet = new Set<string>();

    busMapData.seatList.forEach((seat) => {
      if (seat.isOccupied && seat.passenger?.seller) {
        agentsSet.add(seat.passenger.seller);
      }
    });

    return Array.from(agentsSet).map((agentName) => ({
      name: agentName,
      color: getAgentColor(busMapData, agentName),
      seatCount: getAgentSeatCount(busMapData, agentName),
      revenue: getAgentRevenue(busMapData, agentName),
    }));
  }, [busMapData]);
};
